import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useSEO } from "@/hooks/useSEO";
import HeroSection from "./components/HeroSection";
import FeatureGrid from "./components/FeatureGrid";
import StatsSection from "./components/StatsSection";
import CategoryGrid from "./components/CategoryGrid";
import ArticleGrid from "./components/ArticleGrid";
import CTASection from "./components/CTASection";
import Testimonial from "./components/Testimonial";
import { useEffect } from "react";

const homeSEO = {
  title: "Hipobuy Spreadsheet | Le meilleur outil de gestion budgétaire et suivi des dépenses",
  description:
    "Découvrez Hipobuy Spreadsheet, le système intelligent pour suivre vos dépenses, optimiser votre budget et contrôler vos finances personnelles facilement. Alternative puissante aux applications financières, compatible Google Sheets et Excel, sans abonnement.",
  keywords:
    "hipobuy spreadsheet, gestion financière personnelle, tableau budget Excel, suivi dépenses mensuelles, outil budget intelligent, automatisation financière, hipobuy spreadsheet template, hipobuy spreadsheet download, hipobuy budgeting spreadsheet, hipobuy expense tracker",
  canonicalPath: "/",
  ogType: "website",
  jsonLd: {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Hipobuy Spreadsheet",
    url: "https://hipobuyspreadsheets.site/",
    description:
      "Le système intelligent pour suivre vos dépenses, optimiser votre budget et contrôler vos finances personnelles facilement.",
    inLanguage: "fr",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: "https://hipobuyspreadsheets.site/search?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  },
};

const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Hipobuy Spreadsheet",
  url: "https://hipobuyspreadsheets.site/",
  description:
    "Hipobuy Spreadsheet est le système intelligent de suivi des achats et du budget personnel, compatible Google Sheets et Excel.",
  sameAs: [
    "https://www.instagram.com/",
    "https://www.pinterest.com/",
    "https://x.com/",
  ],
};

export default function Home() {
  useSEO(homeSEO);

  // Inject a second JSON-LD for Organization (separate from WebSite)
  const siteUrl = () => {
    if (typeof import.meta !== "undefined" && import.meta.env?.VITE_SITE_URL) {
      return import.meta.env.VITE_SITE_URL as string;
    }
    return "https://hipobuyspreadsheets.site";
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "seo-org-jsonld";
    script.textContent = JSON.stringify(
      {
        ...orgJsonLd,
        url: siteUrl(),
      },
      null,
      2
    );
    const existing = document.getElementById("seo-org-jsonld");
    if (existing) existing.remove();
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById("seo-org-jsonld");
      if (el) el.remove();
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <StatsSection />
        <CategoryGrid
          title="Découvrez nos"
          subtitle="Collections mode"
          startIndex={0}
          count={4}
        />
        <CategoryGrid
          title="Explorez nos"
          subtitle="Univers tendance"
          startIndex={4}
          count={4}
        />
        <ArticleGrid />
        <CategoryGrid
          title="Complétez votre"
          subtitle="Style unique"
          startIndex={8}
          count={4}
        />
        <CategoryGrid
          title="Accessoirisez"
          subtitle="Votre look"
          startIndex={12}
          count={2}
        />
        <CTASection />
        <Testimonial />
      </main>
      <Footer />
    </>
  );
}